import { axiosInstance as axios } from "@/core/services/api.client";

const prefix = "api/v1/tenant/";
const prefixV2 = "api/v2/tenant/";

export default {
  getServersData: async (criteria?: any) =>
    (await axios.get(prefixV2 + "statistic/server", { params: criteria })).data,

  getServerMetrics: async (criteria?: any) =>
    (
      await axios.get(prefixV2 + "statistic/server/metrics", {
        params: criteria,
      })
    ).data,

  getDomains: async () =>
    (await axios.get("https://api.pl.thebcr.com/v2/tenant/it/domains")).data,

  createDomain: async (formData: any) =>
    (
      await axios.post(
        "https://api.pl.thebcr.com/v2/tenant/it/domains",
        formData
      )
    ).data,

  updateDomainById: async (id: number, formData: any) =>
    (
      await axios.put(
        "https://api.pl.thebcr.com/v2/tenant/it/domains/" + id,
        formData
      )
    ).data,

  checkDomainById: async (id: number) =>
    (
      await axios.post(
        "https://api.pl.thebcr.com/v2/tenant/it/domains/" + id + "/check"
      )
    ).data,

  refreshDomainById: async (id: number) =>
    (
      await axios.get(
        "https://api.pl.thebcr.com/v2/tenant/it/domains/" + id + "/refresh"
      )
    ).data,

  checkDomainDnsById: async (id: number) =>
    (
      await axios.put(
        "https://api.pl.thebcr.com/v2/tenant/it/domains/" + id + "/dns"
      )
    ).data,

  deleteDomainById: async (id: number) =>
    (await axios.delete("https://api.pl.thebcr.com/v2/tenant/it/domains/" + id))
      .data,
};
